import { IJoinedRoomState } from '../Core/State/IJoinedRoomState';

type SidePotLike = { amount?: number | null };
type PlayerLike = { currentBet?: number | null };

/**
 * Computes the real time total pot for Texas Hold'em as:
 * visiblePot + sum(visibleSidePots[].amount) + sum(players[].currentBet)
 */
export const computeTexasRealTimeTotalPot = (
    visiblePot: number | null | undefined,
    visibleSidePots: Array<SidePotLike> | null | undefined,
    players: Array<PlayerLike> | null | undefined
): number => {
    const base = Number(visiblePot || 0);
    const side = (visibleSidePots || []).reduce((acc, p) => acc + Number((p && p.amount) != null ? p.amount : 0), 0);
    // If side pots are present, their amounts already reflect consolidated all-in contributions.
    // To avoid double-counting, exclude outstanding currentBet when side pots exist.
    if (visibleSidePots && visibleSidePots.length > 0) {
        return base + side;
    }
    const outstanding = (players || []).reduce((acc, pl) => acc + Number((pl && pl.currentBet) != null ? pl.currentBet : 0), 0);
    return base + outstanding;
};

/**
 * Returns the preset base pot value for the current room.
 * - Texas: real time total pot (computeTexasRealTimeTotalPot)
 * - Others (e.g., AoF): server pot
 */
export const getTexasPresetBasePot = (roomState: IJoinedRoomState): number => {
    if (roomState.type === 'texas') {
        return computeTexasRealTimeTotalPot(
            roomState.visiblePot,
            roomState.visibleSidePots as Array<SidePotLike>,
            roomState.players as Array<PlayerLike>
        );
    }
    return roomState.pot || 0;
};


